var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:({
    value: _vm.toolTipText,
    disabled: _vm.toolTipText === '',
  }),expression:"{\n    value: toolTipText,\n    disabled: toolTipText === '',\n  }",modifiers:{"bottom":true}}],staticClass:"p-button-primary set-arrests-button",attrs:{"label":_vm.$t('setArrestsButton.label'),"icon":_vm.isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check',"disabled":_vm.isDisabled},on:{"click":_vm.setArrests}})}
var staticRenderFns = []

export { render, staticRenderFns }